import React, { useEffect } from 'react';

import useToggle from 'dpl/shared/hooks/useToggle';

import PrivacyChoicesModal from './PrivacyChoicesModal';

export const PRIVACY_CHOICES_TRIGGER_SELECTOR =
  '[data-privacy-choices-trigger]';

/**
 * Bridges the server-rendered "Your Privacy Choices" footer link(s) to the
 * React modal. The trigger lives in the footer ERB partial (so it renders even
 * without JS and can be asserted by view specs); this container is mounted via
 * `data-react-mount-component` and wires the click handler to open the modal.
 */
export default function PrivacyChoicesModalContainer() {
  const [isModalOpen, toggleIsModalOpen] = useToggle(false);

  useEffect(() => {
    const triggers = document.querySelectorAll(
      PRIVACY_CHOICES_TRIGGER_SELECTOR
    );

    function openModal() {
      toggleIsModalOpen(true);
    }

    triggers.forEach(trigger => trigger.addEventListener('click', openModal));

    return () => {
      triggers.forEach(trigger =>
        trigger.removeEventListener('click', openModal)
      );
    };
  }, [toggleIsModalOpen]);

  return (
    <PrivacyChoicesModal
      isOpen={isModalOpen}
      onClose={() => toggleIsModalOpen(false)}
    />
  );
}
